// BetProtect i18n — English & Kinyarwanda translations

export type Language = 'en' | 'rw';

export const SUPPORTED_LANGUAGES: { code: Language; label: string; nativeLabel: string }[] = [
  { code: 'en', label: 'English', nativeLabel: 'English' },
  { code: 'rw', label: 'Kinyarwanda', nativeLabel: 'Ikinyarwanda' },
];

const translations: Record<Language, Record<string, string>> = {
  en: {
    // Nav
    'nav.checkin': 'Daily Check-In',
    'nav.exercises': 'Coping Exercises',
    'nav.guidance': 'Guidance',
    'nav.progress': 'My Progress',
    'nav.profile': 'My Profile',
    'nav.settings': 'Settings',
    'nav.signout': 'Sign Out',
    // Home
    'home.title': 'Daily Check-In',
    'home.subtitle': 'How are you feeling today?',
    'home.streak': 'day streak',
    // Check-in
    'checkin.mood.label': 'How are you feeling right now?',
    'checkin.mood.hint': 'No right or wrong answer — just honest.',
    'checkin.urge.label': 'Urge to gamble right now',
    'checkin.urge.hint': '1 = no urge at all, 10 = very hard to resist.',
    'checkin.triggers.label': "What's on your mind today? (optional)",
    'checkin.triggers.hint': 'Select anything that feels relevant.',
    'checkin.diary.label': 'Anything else on your mind? (optional)',
    'checkin.submit': 'Save today\'s check-in',
    'checkin.submitting': 'Saving...',
    'checkin.success': "Today's check-in saved — well done for showing up today 💚",
    'checkin.edit': "Edit today's entry",
    // Auth
    'auth.signin': 'Sign In',
    'auth.signup': 'Create Account',
    'auth.welcome': 'Welcome back',
    'auth.signin.subtitle': 'Sign in to continue your journey.',
    'auth.create': 'Create your account',
    'auth.create.subtitle': 'Free, private, and no credit card needed.',
    'auth.email': 'Email address',
    'auth.password': 'Password',
    'auth.name': 'What should we call you?',
    'auth.forgot': 'Forgot password?',
    'auth.remember': 'Keep me signed in',
    'auth.signin.btn': 'Sign in',
    'auth.signup.btn': "Create my account — it's free",
    'auth.no.account': 'New to BetProtect?',
    'auth.have.account': 'Already have an account?',
    // Profile
    'profile.title': 'My Profile',
    'profile.streak': 'Day Streak',
    'profile.urge.free': 'Urge-Free Days',
    'profile.exercises': 'Exercises Done',
    'profile.stats': 'Personal Statistics',
    'profile.notifications': 'Notifications & Reminders',
    'profile.preferences': 'Preferences',
    'profile.export': 'Export My Data',
    'profile.export.btn': 'Download CSV',
    // Exercises
    'exercises.title': 'Coping Exercises',
    'exercises.for.you': 'Personalised For You',
    'exercises.all': 'All Exercises',
    'exercises.start': 'Start Exercise',
    'exercises.complete': 'Mark Complete',
    // General
    'general.loading': 'Loading...',
    'general.error': 'Something went wrong. Please try again.',
    'general.save': 'Save',
    'general.cancel': 'Cancel',
    'general.close': 'Close',
    'general.back': 'Back',
    // Compliance
    'compliance.title': 'Rwanda Gambling Regulation',
    'compliance.body': 'BetProtect operates under Rwanda Development Board (RDB) and National Lottery & Gaming Commission (NLGC) guidelines. If you need support, call the Umubano helpline: 3029.',
    // Language
    'lang.toggle': 'Language',
  },
  rw: {
    // Nav
    'nav.checkin': 'Genzura Buri Munsi',
    'nav.exercises': 'Imyitozo yo Gutuza',
    'nav.guidance': 'Ubuyobozi',
    'nav.progress': 'Iterambere Ryanjye',
    'nav.profile': 'Umwirondoro Wanjye',
    'nav.settings': 'Igenamiterere',
    'nav.signout': 'Sohoka',
    // Home
    'home.title': 'Genzura Buri Munsi',
    'home.subtitle': 'Wumva ute uyu munsi?',
    'home.streak': 'iminsi ikurikiranye',
    // Check-in
    'checkin.mood.label': 'Wumva ute ubu?',
    'checkin.mood.hint': 'Nta gisubizo cyiza cyangwa kibi — gusubiza ukuri gusa.',
    'checkin.urge.label': 'Ushaka gukina imbuga z\'ikinamico ubu?',
    'checkin.urge.hint': '1 = nta bushake na bwo, 10 = bigoye cyane kwirinda.',
    'checkin.triggers.label': 'Ni iki kiri mu mutwe wawe uyu munsi? (ntabwo ari ngombwa)',
    'checkin.triggers.hint': 'Hitamo ibyose bishobora kuba bifitanye isano.',
    'checkin.diary.label': 'Hari ikindi kiri mu mutwe wawe? (ntabwo ari ngombwa)',
    'checkin.submit': 'Bika genzura ry\'uyu munsi',
    'checkin.submitting': 'Kubika...',
    'checkin.success': 'Genzura ry\'uyu munsi ryabitswe — wakoze neza kugaragara uyu munsi 💚',
    'checkin.edit': "Hindura inyandiko y'uyu munsi",
    // Auth
    'auth.signin': 'Injira',
    'auth.signup': 'Fungura Konti',
    'auth.welcome': 'Murakaza neza',
    'auth.signin.subtitle': 'Injira gukomeza urugendo rwawe.',
    'auth.create': 'Fungura konti yawe',
    'auth.create.subtitle': 'Ubuntu, bwite, kandi nta karita ya banki irakenewe.',
    'auth.email': 'Aderesi ya imeyili',
    'auth.password': 'Ijambo ry\'ibanga',
    'auth.name': 'Twakwita nde?',
    'auth.forgot': 'Wibagiwe ijambo ry\'ibanga?',
    'auth.remember': 'Nzigame injijwe',
    'auth.signin.btn': 'Injira',
    'auth.signup.btn': 'Fungura konti yanjye — ni ubuntu',
    'auth.no.account': 'Nta konti muri BetProtect?',
    'auth.have.account': 'Usanzwe ufite konti?',
    // Profile
    'profile.title': 'Umwirondoro Wanjye',
    'profile.streak': 'Iminsi Ikurikiranye',
    'profile.urge.free': 'Iminsi Nta Bushake',
    'profile.exercises': 'Imyitozo Yakozwe',
    'profile.stats': 'Imibare Bwite',
    'profile.notifications': 'Imenyesha n\'Ibibutso',
    'profile.preferences': 'Ibyo Nkunda',
    'profile.export': 'Sohora Amakuru Yanjye',
    'profile.export.btn': 'Pakurura CSV',
    // Exercises
    'exercises.title': 'Imyitozo yo Gutuza',
    'exercises.for.you': 'Byagenewe Wowe',
    'exercises.all': 'Imyitozo Yose',
    'exercises.start': 'Tangira Imyitozo',
    'exercises.complete': 'Shyira Nk\'Ikozwe',
    // General
    'general.loading': 'Gutegereza...',
    'general.error': 'Habaye ikibazo. Ongera ugerageze.',
    'general.save': 'Bika',
    'general.cancel': 'Hagarika',
    'general.close': 'Funga',
    'general.back': 'Garuka',
    // Compliance
    'compliance.title': 'Amategeko y\'Ikinamico mu Rwanda',
    'compliance.body': 'BetProtect ikora mu rwego rw\'amabwiriza ya Rwanda Development Board (RDB) na National Lottery & Gaming Commission (NLGC). Niba ukeneye ubufasha, hamagara inzira ya Umubano: 3029.',
    // Language
    'lang.toggle': 'Ururimi',
  },
};

export function getTranslations(language: Language): (key: string) => string {
  const dict = translations[language] ?? translations['en'];
  return (key: string) => dict[key] ?? translations['en'][key] ?? key;
}
